var React = require('react');

function Fullscreen (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"22","cy":"22","r":"20.5","stroke":"black","strokeWidth":"3","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.1262 29.4998H25V32.4998H11.5V18.9998H14.5V28.0178L27.6522 14.9202L18.3663 14.9452L18.351 12.1321L32.5771 12.0938L32.4932 26.2742L29.68 26.2589L29.728 16.9502L17.1262 29.4998Z","fill":"black","key":1})]);
}

Fullscreen.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = Fullscreen;

Fullscreen.default = Fullscreen;
